import { useKeyboardShortcut } from '@databases/react';
import { defaultStoreUtils } from '@databases/redux';
import { selectSelectedValuesCount } from '@databases/redux/cellSelections/selectors';
import { doClearValues } from '@databases/redux/contextual-menu/actions';
import { useCallback } from 'react';

import { CLEAR_SHORTCUT } from '../shortcuts';

interface ClearEntriesKeyboardShorcutProps {
  contentId: string;
}

const useClearEntriesKeyboardShortcut = ({
  contentId,
}: ClearEntriesKeyboardShorcutProps) => {
  const dispatch = defaultStoreUtils.useDispatch();
  const selectedValuesCount = defaultStoreUtils.useSelector((state) =>
    selectSelectedValuesCount(state, { contentId })
  );

  const handleClearValues = useCallback(() => {
    dispatch(doClearValues(contentId));
  }, [contentId, dispatch]);

  // Don't register the shortcut when editing single cell value
  useKeyboardShortcut(selectedValuesCount > 1 ? CLEAR_SHORTCUT : undefined, () =>
    handleClearValues()
  );
};

export default useClearEntriesKeyboardShortcut;
